module.exports = __webpack_public_path__ + "static/img/show-widget-first.81a39a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/widget/show-widget-first.png
// module id = 8P9K
// module chunks = 2